const Messages = {
    SP: "Scissor cuts Paper",
    PR: "Paper covers Rock",
    RL: "Rock crushes Lizard",
    LK: "Lizard poisons Spock",
    KS: "Spock smashes Scissor",
    SL: "Scissor decapitates Lizard",
    LP: "Lizard eats Paper",
    PK: "Paper disproves Spock",
    KR: "Spock vaporizes Rock",
    RS: "Rock crushes Scissor",
    Tie: "Its a TIE!",
    startmessage: "Click on emoji on YOU side to start",
    endmessage: "GAME OVER"
};

export default Messages;
